import { render, staticRenderFns } from "./invoice-summary.vue?vue&type=template&id=60743875&"
import script from "./invoice-summary.vue?vue&type=script&lang=ts&"
export * from "./invoice-summary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports